import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'remitter-button',
  templateUrl: './remitter-button.component.html',
  styleUrl: './remitter-button.component.css'
})
export class RemitterButtonComponent {
  @Input() label?: string;
  @Input() icon?: string;
  @Input() styleClass?: string;
  @Input() size?: string;
  @Input() severity?: string;
  @Input() disabled?: boolean;
  @Output() click = new EventEmitter<void>();

  getStyleClass(){
    let newStyleClass: { [key: string]: boolean } = {
      'rem-btn': true,
      'rem-btn-severity': true,
      'rem-btn-lg': this.size === 'lg',
      'rem-btn-primary': !this.severity || this.severity === 'primary',
      'rem-btn-outline': this.severity === 'outline',
      'rem-btn-secondary': this.severity === 'secondary',
      'rem-btn-info': this.severity === 'info'
    }

    if(!!this.styleClass){
      newStyleClass[this.styleClass] = true;
    }
    return newStyleClass; 
  }
}
